import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const piadinaTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#4b3d2a',
    },
    secondary: {
      main: '#999b30',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#4b3d2a',
    },
  },
};
